<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>King Abdullah II bought 14 properties in the U.K. and the U.S. for more than $106 million total using offshore companies between 2003 and 2017.</p>
    <column-chart
      :data="$options.tsv"
      :social-mode="socialMode"
      :fixed-height="fixedHeight"
      :key="chartKeyId"
      timeseries-key="year"
      y-axis-tick-format="$,"/>
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data, HM Land Registry and U.S. property records</p>
  </div>
</template>

<script>
import { uniqueId } from 'lodash'
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartKingOfJordanProperties',
  data: function () {
    return {
      chartKeyId: uniqueId('chart-key-')
    }
  },
  watch: {
    fixedHeight () {
      this.chartKeyId = uniqueId('chart-key-')
    }
  }
}
</script>

<tsv>
year	value
2003	1429367.00
2004	3701297.00
2005	5381198.00
2008	4684494.00
2011	13188424.00
2012	6500000.00
2013	790000.00
2014	35900000.00
2015	12225000.00
2017	23000000.00
</tsv>
